import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'

export const Icon = styled.span`
    svg {
        ${svgStroke()}
    }
`